export default "__VITE_ASSET__XBlXAJHr__"